import { render, staticRenderFns } from "./404.vue?vue&type=template&id=e0fae69c&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=e0fae69c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0fae69c",
  null
  
)

export default component.exports